import basketApiClient from '../basket/apiClient';
import events from '../events';
import currenciesService from '../currenciesService';
import formatPrice from '../utils/formatPrice';
const initState = {
    error: [],
    success: null,
    status: 0,
    isLoadingBasket: false,
    isLoadingDiscountCode: false,
    discountCodeInput: "",
    selectedShippingMethodId: 0,
    showError: false
};
export const checkoutConfirmation = {
    ...initState,
    basket: {
        basketId: "",
        subtotal: 0,
        subtotalText: "",
        products: [],
        discountCode: { code: "", price: 0, percentage: 0 }
    },
    showDiscountCodeForm() {
        return this.basket.discountCode.code == "";
    },
    checkoutConfirmationinit() {
        events.onCurrencyChanged.subscribe(currency => {
            this.applyCurrencyExchange(currency);
        });
    },
    updateShipment(shipmentId) {
        this.isLoadingBasket = true;
        basketApiClient.updateShipment({ shipmentId: shipmentId })
            .then(data => {
            this.basket = data;
            this.isLoadingBasket = false;
            this.applyCurrencyExchange(currenciesService.getRate());
        })
            .catch((err) => this.error.push(err));
    },
    applyCurrencyExchange(currency) {
        if (currency && currency.rate !== 1) {
            this.basket.products.forEach(product => {
                var _a, _b, _c, _d;
                const foreignPrice = ((_b = (_a = product.discount) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : product.price) * currency.rate;
                const foreignTotalPriceText = ((_d = (_c = product.discount) === null || _c === void 0 ? void 0 : _c.totalPrice) !== null && _d !== void 0 ? _d : product.total) * currency.rate;
                product.foreignPriceText = formatPrice(foreignPrice, currency.currency);
                product.foreignTotalPriceText = formatPrice(foreignTotalPriceText, currency.currency);
            });
            const foreignSubtotalPrice = this.basket.subtotal * currency.rate;
            this.basket.foreignSubtotalText = formatPrice(foreignSubtotalPrice, currency.currency);
        }
        else {
            this.basket.products.forEach(product => {
                product.foreignPriceText = '';
                product.foreignTotalPriceText = '';
            });
            this.basket.foreignSubtotalText = '';
        }
    },
    async updateShipmentAddress(address) {
        await basketApiClient.updateShipmentAddress(address);
    },
    formatPrice(price) {
        return formatPrice(price, "NOK");
    },
    loadBasket() {
        this.isLoadingBasket = true;
        basketApiClient.get()
            .then(data => {
            this.basket = data;
            this.isLoadingBasket = false;
            this.applyCurrencyExchange(currenciesService.getRate());
        })
            .catch((err) => this.error.push(err));
    },
    async applyCode() {
        this.isLoadingDiscountCode = true;
        this.showError = false;
        if (this.discountCodeInput) {
            let res = await basketApiClient.applyDiscountCode(this.discountCodeInput);
            if (res.status == 0) {
                this.loadBasket();
            }
            else {
                this.showError = true;
            }
        }
        this.isLoadingDiscountCode = false;
    },
    async removeCode() {
        this.isLoadingDiscountCode = true;
        await basketApiClient.removeDiscountCode(this.basket.discountCode.code);
        this.loadBasket();
        this.isLoadingDiscountCode = false;
    },
};
